export const companyStepFormsTitle = ['basic_information', 'other_information', 'contact_information', 'confirmation'];
